import http from '../utils/http-common'

const getAll = (param, cancelToken) => {
  return http.get('/inventory-counts', { params: param, cancelToken: cancelToken?.token })
}

const get = (id) => {
  return http.get(`/inventory-counts/${id}`)
}

const create = (data) => {
  return http.post('/inventory-counts', data)
}

const complete = (data) => {
  return http.post('/inventory-counts/complete', data)
}

const update = (id, data) => {
  return http.put(`/inventory-counts/${id}`, data)
}

const remove = (id) => {
  return http.delete(`/inventory-counts/${id}`)
}

const cancel = (data) => {
  return http.post(`/inventory-counts/cancel`, data)
}

const getAllItems = (param, cancelToken) => {
  return http.get('/inventory-count-items', { params: param, cancelToken: cancelToken?.token })
}

const getItem = (id) => {
  return http.get(`/inventory-count-items/${id}`)
}

const createItem = (data) => {
  return http.post('/inventory-count-items', data)
}

const updateItem = (id, data) => {
  return http.put(`/inventory-count-items/${id}`, data)
}

const removeItem = (id) => {
  return http.delete(`/inventory-count-items/${id}`)
}

const getInventoryCountStatuses = () => {
  return http.get('/inventory-count-statuses')
}

const getInventoryCountItemStatuses = (params) => {
  return http.get('/inventory-count-item-statuses', { params })
}

const assignUser = (data) => {
  return http.post('/inventory-count-items/assign-user', data)
}

const removeItems = (data) => {
  return http.delete('/inventory-count-items', data)
}

const cancelItems = (data) => {
  return http.post('/inventory-count-items/bulk-cancel', data)
}

const recountItems = (data) => {
  return http.post('/inventory-count-items/recount', data)
}

const updateItemNote = (data) => {
  return http.post('/inventory-count-items/note', data)
}

const setUpdatedToSystem = (data) => {
  return http.post('/inventory-count-items/set-updated', data)
}

const getInventoryCountItemGroups = (data) => {
  return http.post('/inventory-count-items/groups', data)
}

const getInventoryCountItems = (data) => {
  return http.post('/inventory-count-items/items', data)
}

const countInventoryItems = (data) => {
  return http.post(`/inventory-count-items/count`, data)
}

const getLocationItems = (data) => {
  return http.post(`/inventory-count-items/location-items`, data)
}

const addInventoryItem = (data) => {
  return http.post(`/inventory-count-items/add`, data)
}

const unassignAllUserLocations = (data) => {
  return http.post(`/inventory-count-items/unassign-all-user-locations`, data)
}

const inventoryCountCheck = (data) => {
  return http.post(`/inventory-counts/inventory-check`, data)
}

const notFoundItem = (data) => {
  return http.post(`/inventory-count-items/not-found-item`, data)
}

const exportCountItems = (id) => {
  return http.get(`/inventory-count-items/export/${id}`)
}

const InventoryCountDataService = {
  getAll,
  get,
  create,
  update,
  remove,
  cancel,
  getAllItems,
  getItem,
  createItem,
  updateItem,
  removeItem,
  removeItems,
  recountItems,
  getInventoryCountStatuses,
  getInventoryCountItemStatuses,
  assignUser,
  updateItemNote,
  setUpdatedToSystem,
  getInventoryCountItemGroups,
  getInventoryCountItems,
  complete,
  countInventoryItems,
  getLocationItems,
  addInventoryItem,
  unassignAllUserLocations,
  inventoryCountCheck,
  cancelItems,
  notFoundItem,
  exportCountItems,
}
export default InventoryCountDataService
